import React, { useState } from 'react';

const COUNTRIES = [
  { code: '+1', iso: 'US', label: '🇺🇸 US' },
  { code: '+91', iso: 'IN', label: '🇮🇳 IN' },
  { code: '+44', iso: 'GB', label: '🇬🇧 UK' },
  { code: '+61', iso: 'AU', label: '🇦🇺 AU' },
  { code: '+65', iso: 'SG', label: '🇸🇬 SG' },
  { code: '+971', iso: 'AE', label: '🇦🇪 AE' },
  { code: '+55', iso: 'BR', label: '🇧🇷 BR' },
  { code: '+49', iso: 'DE', label: '🇩🇪 DE' },
  { code: '+33', iso: 'FR', label: '🇫🇷 FR' },
  { code: '+81', iso: 'JP', label: '🇯🇵 JP' },
];

export default function PhoneInput({ value, onChange, disabled, placeholder = "Your phone number", autoFocus }) {
  const [country, setCountry] = useState('+1');
  const [local, setLocal] = useState(value || '');

  const handleLocalChange = (e) => {
    const digits = e.target.value.replace(/[^\d]/g, '');
    setLocal(digits);
    onChange(`${country}${digits}`);
  };

  const handleCountryChange = (e) => {
    setCountry(e.target.value);
    onChange(`${e.target.value}${local}`);
  };

  return (
    <div className="flex items-stretch gap-2">
      <select
        value={country}
        onChange={handleCountryChange}
        disabled={disabled}
        className="bg-[#0A0F1C] border border-[#22304A] rounded-lg px-3 py-3 text-white text-sm focus:border-[#3EF1C7] focus:outline-none"
      >
        {COUNTRIES.map(c => (
          <option key={c.iso} value={c.code}>{c.label} {c.code}</option>
        ))}
      </select>
      <input
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        value={local}
        onChange={handleLocalChange}
        disabled={disabled}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className="flex-1 bg-[#0A0F1C] border border-[#22304A] rounded-lg px-4 py-3 text-white placeholder-[#64748B] focus:border-[#3EF1C7] focus:outline-none"
      />
    </div>
  );
}
